<span [class.fs25]="term.newLiner()" class="enote-title" *ngIf="!term.initial_component">
  <span *ngIf="term.is_open_text || term.name || term.keyword.name" contenteditable="false">
    <span #term_name_span [tooltip]="term.control_value_class"
          [class]="term.control_value_class"
          [class.term]="term.isTermTypeChild()"
          [class.fs16]="term.isTermTypeChild() && !term.parent_term.name.includes('Prescription')"
          [class.primary-title]="term.component_level == 2"
          [class.secondary-title]="term.component_level == 3"
          [class.tertiary-title]="term.component_level == 4">
      {{term.is_open_text ? term.open_text?.trim() : term.controlText}}
      <span class="fs16">{{(!term.isComponentTypeChild() && !term.is_open_text && !term.has_term_control_values()) ? '.' : ''}}</span>
    </span>
  </span>
</span>
<span [class.d-block]="term.newLiner()"></span>
<ng-container *ngFor="let term_control of term.custom_term_control_with_values(); let i=index">
    <app-note-custom-control-value [term]="term" [term_control]="term_control" [control_index]="i"></app-note-custom-control-value>
    <span class="fs16" style="margin-left: -3px"  *ngIf="i < term.custom_term_control_with_values().length - 3 ">,</span>
    <span class="fs16" *ngIf="(term.custom_term_control_with_values().length - 2) == i">and</span>
    <span class="fs16" *ngIf="(term.custom_term_control_with_values().length -1) == i">.</span>
</ng-container>


<ng-container *ngIf="term.hasChildren()">
  <ng-container *ngFor="let child_terms of term.children_groups;let i=index">
    <span class="fs" [class.indent-component]="i > 0" [class.enote-term]="child_terms.length > 1 && !child_terms[1].isComponentTypeChild() || term.is_open_text">
      <ng-container *ngFor="let child_term of child_terms">
        <ng-container *ngIf="child_term.showTerm() && child_term.showComponent">
          <app-print-enote   [class.pb-sm]="!child_term.isComponentTypeChild() && child_term.parent_term && child_term.parent_term.name.includes('Prescription')"  [ngClass]="child_term.isComponentTypeChild() && !child_term.is_open_text ? 'flex-component' : '' "  [class.d-block]="!child_term.isComponentTypeChild() && child_term.parent_term && child_term.parent_term.name.includes('Prescription')" *ngIf="!child_term._destroy" [term]="child_term"></app-print-enote>
        </ng-container>
      </ng-container>
    </span>
  </ng-container>
</ng-container>
